import { render, staticRenderFns } from "./CarrierLogo.vue?vue&type=template&id=1745e1f4&lang=pug&"
import script from "./CarrierLogo.vue?vue&type=script&lang=js&"
export * from "./CarrierLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports